/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fixed_Event_Overlap_SuccessInputs */

const en_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed event overlap for all events successfully`)
};

const fr_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chevauchement des événements corrigé avec succès`)
};

const de_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Ereignisüberschneidung wurde erfolgreich behoben.`)
};

const it_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovrapposizione degli eventi corretta per tutti gli eventi`)
};

const ru_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Устранено перекрытие событий для всех событий.`)
};

const es_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se solucionó con éxito la superposición de eventos para todos los eventos`)
};

const zh_cn2_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所有事件的事件重叠问题均已成功解决。`)
};

const ja_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのイベントの重複を修正しました`)
};

const hi_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी इवेंट्स के लिए इवेंट ओवरलैप को सफलतापूर्वक ठीक कर दिया गया है।`)
};

const pt_pt2_fixed_event_overlap_success = /** @type {(inputs: Fixed_Event_Overlap_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobreposição de eventos corrigida para todos os eventos com sucesso.`)
};

/**
* | output |
* | --- |
* | "Fixed event overlap for all events successfully" |
*
* @param {Fixed_Event_Overlap_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const fixed_event_overlap_success = /** @type {((inputs?: Fixed_Event_Overlap_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fixed_Event_Overlap_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_fixed_event_overlap_success(inputs)
	if (locale === "de") return de_fixed_event_overlap_success(inputs)
	if (locale === "it") return it_fixed_event_overlap_success(inputs)
	if (locale === "ru") return ru_fixed_event_overlap_success(inputs)
	if (locale === "es") return es_fixed_event_overlap_success(inputs)
	if (locale === "zh-CN") return zh_cn2_fixed_event_overlap_success(inputs)
	if (locale === "ja") return ja_fixed_event_overlap_success(inputs)
	if (locale === "hi") return hi_fixed_event_overlap_success(inputs)
	if (locale === "pt-PT") return pt_pt2_fixed_event_overlap_success(inputs)
	return en_fixed_event_overlap_success(inputs)
});